import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUser } from '@/contexts/UserContext/UserContext';
import useAuth from '@/hooks/useAuth';

export default function LogoutPage() {
  const { logout } = useAuth0();
  const { clearUser } = useUser();
  const { logOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Clear all user data
    clearUser();
    localStorage.removeItem('user');
    
    // Clear all Auth0 related data
    localStorage.removeItem('auth0.is.authenticated');
    sessionStorage.removeItem('auth0.is.authenticated');
    
    // Clear all cookies that might be related to auth
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
    
    // Call the custom logout function which also calls Auth0 logout
    logOut();
    
    // Also call Auth0 logout directly to ensure complete logout
    logout({ 
      logoutParams: { 
        returnTo: window.location.origin 
      }
    });
    
    // Redirect to home page after a short delay
    const timer = setTimeout(() => {
      navigate('/');
    }, 1500);

    return () => clearTimeout(timer);
  }, [logout, clearUser, logOut, navigate]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-semibold">Logging out...</h2>
        <p className="mt-2 text-gray-600">Please wait while we log you out.</p>
        <p className="mt-2 text-gray-500 text-sm">You will be redirected to the home page shortly.</p>
      </div>
    </div>
  );
}